export default __webpack_public_path__ + "static/media/property-safety.be59a1b0.svg";